import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { AlertContainer } from '.'
import './alerts.css'

export class Alerts extends Component {
    
    static propTypes = {
        alerts: PropTypes.array.isRequired,
    }
    
    render() {
        const { alerts } = this.props
        
        let toRender = []
        alerts.forEach(function(alert, index) {
            toRender.push(<AlertContainer key={`alert${index}`} alert={alert} />)
        })
        
        return (
            <div className="alert-container">
                {toRender}
            </div>
        );
    }
}
